import ServiceBase from './ServiceBase'
import homeQuery from '@/grapql/queries/home.graphql'
import black5Query from '@/grapql/queries/black5.graphql'
import megaMenuQuery from '@/grapql/queries/megamenu.graphql'
import promptsQuery from '@/grapql/queries/prompts.graphql'
import type { TravelerStory } from '@/types/TravelerStory'
import type { Inspiration } from '@/types/Inspiration'

class HomeService extends ServiceBase {
  private promptsDataPromise: Promise<any> | null = null

  private getPromptsData(): Promise<any> {
    if (!this.promptsDataPromise) {
      this.promptsDataPromise = this.gqlQuery(promptsQuery).finally(() => {
        setTimeout(() => {
          this.promptsDataPromise = null
        }, 0)
      })
    }
    return this.promptsDataPromise
  }
  async getRoute(path: any) {
    const apiUrl = 'common/home/get_route'
    return new Promise<any>((resolve, reject) => {
      this.webPost(
        path,
        (result) => {
          resolve(result)
        },
        apiUrl,
        (error) => {
          reject(error)
        },
        15000,
        3
      )
    })
  }

  async home(): Promise<any> {
    try {
      return await this.gqlQuery(homeQuery, undefined, 'no-cache')
    } catch (error) {
      // GraphQL not available in local dev, return empty data
      console.warn('[HomeService] GraphQL unavailable, returning empty data')
      return {
        hotProductModules: [],
        couponProductModules: [],
        blogModule: []
      }
    }
  }

  async black5(): Promise<any> {
    try {
      return await this.gqlQuery(black5Query)
    } catch (error) {
      console.warn('[HomeService] GraphQL unavailable for black5')
      return { black5ProductModules: [] }
    }
  }

  async menu(): Promise<any> {
    try {
      return await this.gqlQuery(megaMenuQuery)
    } catch (error) {
      console.warn('[HomeService] GraphQL unavailable for menu')
      return { megaMenuModule: [] }
    }
  }

  async getRecaptchaConfig(): Promise<any> {
    const apiUrl = 'common/home/recaptcha_config'
    return new Promise((resolve, reject) => {
      this.webGet(
        {},
        (result) => {
          resolve(result)
        },
        apiUrl,
        (error) => {
          reject(error)
        },
        3000,
        3
      )
    })
  }

  async getMenuItemsByCategoryIds(catIds: number[]) {
    const apiUrl = 'module/pavmegamenu/getMenuItemsByCategoryIds&catIds=' + catIds.join(',')
    return new Promise((resolve, reject) => {
      this.webGet(
        {},
        (result) => {
          resolve(result)
        },
        apiUrl,
        (error) => {
          reject(error)
        },
        5000,
        3
      )
    })
  }
  async getPromptPresets(): Promise<string[]> {
    try {
      const data = await this.getPromptsData()
      return data.promptsModule ?? []
    } catch (error) {
      console.warn('[HomeService] Failed to fetch prompt presets')
      return []
    }
  }

  async getTravelerStories(): Promise<TravelerStory[]> {
    try {
      const data = await this.getPromptsData()
      return data.travelerStoriesModule ?? []
    } catch (error) {
      console.warn('[HomeService] Failed to fetch traveler stories')
      return []
    }
  }

  async getInspirations(): Promise<Inspiration[]> {
    try {
      const data = await this.getPromptsData()
      return data.inspirationsModule ?? []
    } catch (error) {
      console.warn('[HomeService] Failed to fetch inspirations')
      return []
    }
  }

  async subscribeNewsletter(
    email: string
  ): Promise<{ state: number; success?: string; error?: string }> {
    const apiUrl = 'module/pavnewsletter/subscribe'
    return new Promise((resolve, reject) => {
      this.webPost(
        { email },
        (result: any) => {
          resolve(result)
        },
        apiUrl,
        (error: any) => {
          reject(error)
        }
      )
    })
  }
}

export default new HomeService()
